export enum BiErrorCodes {
  REPORT_SIZE_EXCEEDED = "ReportSizeExceeded",
}
